var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hcm-card',{attrs:{"resource":_vm.resource,"cardImage":_vm.resource.image,"cardTitle":_vm.resource.title,"resourceUrl":_vm.resource.slug,"externalResource":true,"cardText":_vm.resource.description,"hasSource":false,"hasShare":false}})}
var staticRenderFns = []

export { render, staticRenderFns }